import Repository from "@shared/services/api/abstracts/Repository";
import { AxiosRequestConfig } from "axios";
import { PublicMembershipGroupSerializer } from "../../types";
import { createRichMembershipGroupSchema } from "../../utils/schema";

export default class PublicBasedMembershipGroupRepository extends Repository<PublicMembershipGroupSerializer> {
  public readonly repositoryName = "PublicBasedMembershipGroupRepository";

  public readonly endpoint = "api/public/memberships/membership-groups/";

  public async retrieve(
    id: number | string, // can accept the membership group's id or the slug
    config?: AxiosRequestConfig
  ): Promise<PublicMembershipGroupSerializer> {
    const { data, headers } = await this.request(
      this.buildUrl("retrieve", { id }),
      config
    );

    // add rich schema to returned object
    // TODO this should not be done here
    const membershipGroupSchema = createRichMembershipGroupSchema(data);
    return { ...data, membershipGroupSchema, headers };
  }
}
